export const analysis = [
  {
    analysisMethodDescription:
      '本模块采用卡方检验作为分析方法，主要用于两组样本或是两个分类变量之间差异性的分析。其根本思想是利用样本的实际频数和理论频数的吻合度，来判断样本是否符合预期。',
    title: '症状缓解时间与病程差异性分析',
    desc: '当前差异性分析是将“结合基因检测结果治疗后多久，患者症状基本缓解”设置为“症状缓解时间”作为一组变量，将“进行基因检测前，患者病程”设置为“病程”作为一组变量，进行两组分类变量之间的差异性分析。',
    crossTitle: '交叉分析表',
    crossDesc:
      '通过对“结合基因检测结果治疗后多久，患者症状基本缓解”与“进行基因检测前，患者病程”进行调查分析，主要指标采用“<3日”，“3-5日”，“>5日”等，得到如下二维数组调查表。',
    table: {
      header: [
        { prop: 'baseTopicName', label: ['分类指标'] },
        { prop: '1', label: ['<3日'] },
        { prop: '2', label: ['3-5日'] },
        { prop: '3', label: ['>5日'] }
      ],
      value: [
        {
          baseTopicName: ['≤1周'],
          1: ['266(13.03%)'],
          2: ['466(22.83%)'],
          3: ['300(14.70%)']
        },
        {
          baseTopicName: ['>1周'],
          1: ['219(10.73%)'],
          2: ['428(20.97%)'],
          3: ['362(17.74%)']
        }
      ]
    },
    echart: {
      '≤1周': [266, 466, 300],
      '>1周': [219, 428, 362]
    },
    echartHeader: ['<3日', '3-5日', '>5日'],
    chiSquareTable: {
      secondTitle: '病程',
      header: [
        { prop: 'headerTit', label: ['题目'] },
        { prop: 'headerMc', label: ['名称'] },
        { prop: '1', label: ['≤1周'] },
        { prop: '2', label: ['>1周'] },
        { prop: 'headerZJ', label: ['总计'] },
        { prop: 'headerX2', label: ['X²'] },
        { prop: 'headerP', label: ['p'] }
      ],
      title: '症状缓解时间',
      value: [
        {
          headerTit: ['病程'],
          headerMc: ['<3日'],
          1: ['266'],
          2: ['219'],
          headerZJ: [485],
          headerX2: [''],
          headerP: ['']
        },
        {
          headerTit: [''],
          headerMc: ['3-5日'],
          1: ['466'],
          2: ['428'],
          headerZJ: [894],
          headerX2: [''],
          headerP: ['']
        },
        {
          headerTit: [''],
          headerMc: ['>5日'],
          1: ['300'],
          2: ['362'],
          headerZJ: [662],
          headerX2: ['11.72'],
          headerP: ['0.00']
        },
        {
          headerTit: ['总计'],
          headerMc: [''],
          1: [''],
          2: [''],
          headerZJ: [2041],
          headerX2: [''],
          headerP: ['']
        }
      ]
    },
    kafangObj: {
      allChartTypeV3: '1,2,3,4',
      biInfoId: 25,
      chartTableTypeV3: '2',
      chartType: '11',
      createDt: 1706255739000,
      id: 41,
      isDelete: 0,
      questionnaireCrossGroupId: 1163,
      resultP: '0.78',
      resultSystem:
        '本期调查采样数据如下：共19个样本，其中选择“≤18岁”关联“东北”的共计1个样本，占比5.26%；选择“≤18岁”关联“华北”的共计1个样本，占比5.26%；选择“≤18岁”关联“华中”的共计0个样本，占比0.00%；选择“≤18岁”关联“华南”的共计0个样本，占比0.00%；选择“≤18岁”关联“西南”的共计1个样本，占比5.26%；选择“≤18岁”关联“西北”的共计0个样本，占比0.00%；选择“18岁-35岁”关联“东北”的共计0个样本，占比0.00%；选择“18岁-35岁”关联“华北”的共计1个样本，占比5.26%；选择“18岁-35岁”关联“华中”的共计1个样本，占比5.26%；选择“18岁-35岁”关联“华南”的共计0个样本，占比0.00%；选择“18岁-35岁”关联“西南”的共计0个样本，占比0.00%；选择“18岁-35岁”关联“西北”的共计1个样本，占比5.26%；选择“36岁-50岁”关联“东北”的共计2个样本，占比10.53%；选择“36岁-50岁”关联“华北”的共计0个样本，占比0.00%；选择“36岁-50岁”关联“华中”的共计1个样本，占比5.26%；选择“36岁-50岁”关联“华南”的共计0个样本，占比0.00%；选择“36岁-50岁”关联“西南”的共计1个样本，占比5.26%；选择“36岁-50岁”关联“西北”的共计0个样本，占比0.00%；选择“51岁-65岁”关联“东北”的共计0个样本，占比0.00%；选择“51岁-65岁”关联“华北”的共计1个样本，占比5.26%；选择“51岁-65岁”关联“华中”的共计1个样本，占比5.26%；选择“51岁-65岁”关联“华南”的共计1个样本，占比5.26%；选择“51岁-65岁”关联“西南”的共计1个样本，占比5.26%；选择“51岁-65岁”关联“西北”的共计0个样本，占比0.00%；选择“＞65岁”关联“东北”的共计1个样本，占比5.26%；选择“＞65岁”关联“华北”的共计1个样本，占比5.26%；选择“＞65岁”关联“华中”的共计0个样本，占比0.00%；选择“＞65岁”关联“华南”的共计0个样本，占比0.00%；选择“＞65岁”关联“西南”的共计2个样本，占比10.53%；选择“＞65岁”关联“西北”的共计1个样本，占比5.26%。',
      resultUser: '',
      resultX2: '14.89',
      secondTitle: '籍贯',
      showSort: 1,
      summary: '',
      tableTypeV3: '2',
      title: '年龄',
      xTopicId: 99973,
      yTopicId: 99975,
      znResultSystem:
        '在列表中，不允许存在期望频数小于1的单元格，也不应出现大量期望频数小于5的单元格。如果交叉列联表中有超过30%的单元格的期望频数小于5，那么卡方检验的适用条件将不满足，因此一般不推荐使用卡方检验。在这种情况下，可以考虑采用其他适用的统计方法进行分析。',
      znTableIsShow: 1
    },
    isDelete: 0,
    resultSystem: `
    <p>本期调查采样数据如下：共2041个样本，其中选择“≤1周”关联“<3日”的共计266个样本，占比13.03%；选择“≤1周”关联“3-5日”的共计466个样本，占比22.83%；选择“≤1周”关联“>5日”的共计300个样本，占比14.70%；选择“>1周”关联“<3日”的共计219个样本，占比10.73%；选择“>1周”关联“3-5日”的共计428个样本，占比20.97%；选择“>1周”关联“>5日”的共计362个样本，占比17.74%。</p>
    <p>对上述数据样本通过交叉分析图及卡方等方式进行分析得出:</p>
    <p>本期样本总量n=2041，通过卡方检验 进行症状缓解时间与病程的差异性分析，计算得出X²=11.72 p=0.00。因此，症状缓解时间与病程具有统计学意义（p<0.05）</p>
    <p>总结可知：不同（症状缓解时间）对于（病程）具有显著性差异（p<0.05）， 卡方分析会随着样本量变化，分析结果产生些许不同。</p>
    `,
    resultUser: '',
    summary: '',
    znResultSystem:
      '在列表中，不允许存在期望频数小于1的单元格，也不应出现大量期望频数小于5的单元格。如果交叉列联表中有超过30%的单元格的期望频数小于5，那么卡方检验的适用条件将不满足，因此一般不推荐使用卡方检验。在这种情况下，可以考虑采用其他适用的统计方法进行分析。',
    id: 41,
    resultX2: '11.72',
    resultP: '0.00'
  }
];
